import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';


@Component({
  selector: 'atram-autocomplete-dropdown',
  templateUrl: './atram-autocomplete-dropdown.component.html',
  styleUrls: ['./atram-autocomplete-dropdown.component.less']
})
export class AtramAutocompleteDropdownComponent implements OnInit {

  @Input() parentFormGroup!: FormGroup;
  @Input() controlName: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() isSearchable: boolean = true;
  @Input() isRequired: boolean = false;
  @Input() isError: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input('upper-case') upperCase: boolean = false; // directive
  @Input() componentClass: string = '';
  @Input() showTooltip: boolean = true;
  @Input() showButton: boolean = true;
  @Input() switchDisplay: boolean = false;
  @Input() options!: Array<any>;
  @Output('on-search') onSearchEmitter: EventEmitter<string>;
  @Output('on-select') onSelectEmitter: EventEmitter<any>;

  @ViewChild('input')
  input!: ElementRef;

  public showOptions: boolean = false;
  public temporaryOptions: Array<any> | null = [];

  constructor() {
    this.onSearchEmitter = new EventEmitter<string>();
    this.onSelectEmitter = new EventEmitter<any>();
  }

  ngOnInit() {
    const control = this.parentFormGroup.get(this.controlName);
    if (control?.value && control.value.text && control.value.value) {
      if (this.options && this.options.length != 0) {
        const selectedOption: Array<any> = this.options.filter((option: any) => (option.text && option.text.toString().toLowerCase().includes(control.value.text.toString().toLowerCase())));
        if (selectedOption && selectedOption.length != 0) {
          const option: any = selectedOption[0];
          control.setValue({
            text: this.upperCase ? option.text.toUpperCase() : option.text,
            value: this.upperCase ? option.value.toUpperCase() : option.value
          });
        }
      }
      this.input.nativeElement.value = this.switchDisplay ? (this.upperCase ? control.value.value.toUpperCase() : control.value.value) : (this.upperCase ? control.value.text.toUpperCase() : control.value.text);
    } else if (control?.value) {
        // DO NOTHING
    } else {
      this.input.nativeElement.value = '';
    }
    this.onChangeValue();
  }

  onChangeValue(): void {
    const control = this.parentFormGroup.get(this.controlName);
    control?.valueChanges.subscribe(value => {
      if (value && value.text && value.value) {
        this.input.nativeElement.value = this.switchDisplay ? (this.upperCase ? value.value.toUpperCase() : value.value) : (this.upperCase ? value.text.toUpperCase() : value.text);
      } else if (value) {
        // DO NOTHING
      } else {
        this.input.nativeElement.value = '';
      }
    });
  }

  public onSearch(event: Event): void {
    this.showOptions = true;
    let value: any = (event.target as HTMLInputElement).value;
    this.temporaryOptions = this.temporaryOptions ? this.temporaryOptions : this.options;
    if (value && value.length != 0) {
      this.options = this.temporaryOptions.filter((option: any) => (option.text && option.text.toString().toLowerCase().includes(value.toString().toLowerCase())));
      if (this.options && this.options.length != 0) {
        // DO NOTHING
      } else {
        this.parentFormGroup.get(this.controlName)?.setValue({
          text: this.upperCase ? value.toUpperCase() : value,
          value: this.upperCase ? value.toUpperCase() : value
        }, { emitEvent: false });
        this.input.nativeElement.value = this.upperCase ? value.toUpperCase() : value;
      }
      const options: Array<any> = this.temporaryOptions.filter((option: any) => (option.text && option.text.toString().toLowerCase() == value.toString().toLowerCase()));
      if (options && options.length != 0) {
        this.parentFormGroup.get(this.controlName)?.setValue(options[0], { emitEvent: false }​​​​​);
      }
    } else {
      this.options = this.temporaryOptions;
      this.temporaryOptions = null;
      this.parentFormGroup.get(this.controlName)?.setValue('', { emitEvent: false });
      this.input.nativeElement.value = '';
    }
    this.onSearchEmitter.emit(this.upperCase ? value.toUpperCase() : value);
  }

  public onSelect(event: Event, option: any): void {
    this.showOptions = false;
    if (this.temporaryOptions) {
      this.options = this.temporaryOptions;
      this.temporaryOptions = null;
    }
    const selectedOption: any = {
      text: this.upperCase ? option.text.toUpperCase() : option.text,
      value: this.upperCase ? option.value.toUpperCase() : option.value
    };
    this.parentFormGroup.get(this.controlName)?.setValue(selectedOption);
    this.input.nativeElement.value = this.switchDisplay ? (this.upperCase ? option.value.toUpperCase() : option.value) : (this.upperCase ? option.text.toUpperCase() : option.text);
    this.onSelectEmitter.emit(selectedOption);
  }


}
